import { gameLoop } from "./game/gameLoop.js";
import { gameState } from "./game/gameState.js";
import { saveLoad } from "./game/saveLoad.js";
import { uiManager } from "./ui/uiManager.js";
import { initSVGSpriteSheet } from "./assets/icons.js";
import { network } from "./network.js";

const state = new gameState();
const ui = new uiManager(state);
const sl = new saveLoad(state, ui);

initSVGSpriteSheet();

sl.loadState();

ui.init(state);

const game = new gameLoop(state, ui, sl);

//TODO: REMOVE THIS
const startingTile = { 
  xPos: state.map.centerX || 0, 
  yPos: state.map.centerY || 0 
};
network.connect(startingTile);


game.start();






//idk what this is
// const button = document.getElementById("test-server");
// button.addEventListener("click", () => {
//     console.log(state.saveGame());
// })